import React from 'react'
import { ListItemIcon } from '@material-ui/core'

export default function MListItemIcon(props) {
    const { children, ...otherProps } = props;
    return (
        <ListItemIcon {...otherProps}>
            {children}
        </ListItemIcon>
    )
}
